import {gql} from 'apollo-angular';

export const GET_ROOKIE_DISTRICTS = gql`
  query GetRookieDistricts {
    rookieDistricts {
      id
      name
      eventType
      state
    }
  }
`;
